import { cn } from "tools/ui";
import { FormattedMessage as FM } from "react-intl";

const STYLE_BASE =
  "bg-gradient-to-r from-[#FFCC00] from-50% via-[#FFA000] via-100% h-[107px]  flex flex-col justify-center items-center rounded-2xl shadow-md mb-[30px] px-4 l w-full";

const TitleHero = ({ name, desc, style, logo, fullMessage }) => {
  const styleMx = logo ? "mx-none" : "mx-auto";
  const styleMb = logo ? "!mb-0" : "";

  return (
    <div className="max-md:space-y-4 md:flex md:space-x-2 justify-between items-center mb-[30px] ">
      {logo && (
        <figure className="flex justify-center items-center">
          <img src={logo} className="md:h-[100px] h-[60px] w-auto px-6" />
        </figure>
      )}
      <section className={cn(STYLE_BASE, style, styleMx, styleMb)}>
        <div className=" flex  space-y-1 flex-col justify-center items-center my-auto h-full">
          <h1 className="font-bold text-2xl md:text-[32px] capitalize text-center">
            {fullMessage ? (
              <FM id={fullMessage} />
            ) : (
              <>
                <FM id="hotel.folio.guest.hello" />
                {name && `, ${name.toLowerCase()}`}!
              </>
            )}
          </h1>
          <p className="text-[14px] text-center">
            <FM id={desc} />
          </p>
        </div>
      </section>
    </div>
  );
};
export default TitleHero;
